import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const SessionID = localStorage.getItem("SessionID");

  if (!SessionID) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
